/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import React from 'react';

import Joyride, { STATUS } from 'react-joyride';

import DashboardTooltip from '../dashboardTour/DashboardTooltip';
import { stepsData as dashboardStepsFn } from '../dashboardTour/DashboardTour';

const dashboardSteps = dashboardStepsFn(false);
export const stepsData = () => [
  {
    content: `
      Welcome to the free Self-Help section of your personal medical record! 
      Here, you will find normal MRI and CT scans you can use to compare to your own, articles on common illnesses and injuries, 
      and a few sample normal anatomy and self-help videos
    `,
    disableBeacon: true,
    placement: 'center',
    target: 'body',
    title: 'Self-Help Materials',
  },
  {
    content: (
      <>
        <span>
          A premium version of Self-Help content is also available which provides over 50 videos explaining normal anatomy on MRI and CT as well as normal conditions such as ACL
          tears, multiple sclerosis, and herniated disks. The premium version also grants you access to our library of art, 3D models, and animations that can help you with your
          own scans.
        </span>
        <br />
        <span>
          Finally, you will also have access to a powerful “lay language translator” where you can input any word you may find confusing from your written radiology report and get
          an immediate translation in everyday language.
        </span>
      </>
    ),
    disableBeacon: true,
    placement: 'center',
    target: 'body',
    title: 'Premium Content',
  },
  {
    content: (
      <>
        <span>Thank you for choosing Mediphany and we hope that we are able to help you better understand your radiology results!</span>
        <br />
        <span>Please reach out to us at any time if you have any questions or concerns.</span>
      </>
    ),
    disableBeacon: true,
    locale: { next: 'Finish' },
    placement: 'center',
    target: 'body',
    title: 'Premium Content',
  },
];

export default ({ runJoyride, onOpenPatientDashboard, onCloseJoyride }) => {
  const steps = stepsData();

  const handleCallbackJoyride = (callback) => {
    const { action, status, type, lifecycle } = callback;

    if (action === 'close' && lifecycle === 'complete') {
      if (onCloseJoyride) onCloseJoyride();
    }

    if (action === 'next' && status === STATUS.FINISHED && type === 'tour:end') {
      if (onCloseJoyride) onCloseJoyride();
      if (onOpenPatientDashboard) onOpenPatientDashboard();
    }
  };

  return (
    <>
      <Joyride
        callback={handleCallbackJoyride}
        tooltipComponent={(props) => <DashboardTooltip {...props} totalStep={steps.length} additionalStep={dashboardSteps.length} additionalTotalStep={dashboardSteps.length} />}
        continuous
        showProgress
        showSkipButton
        disableScrolling
        run={runJoyride}
        steps={steps}
        styles={{
          options: {
            arrowColor: '#00000000',
            zIndex: 1000000,
          },
        }}
      />
    </>
  );
};
